export const featureRefreshEvents = {
  /**
   * Something in the household's THINGS changed, wherever the reader is.
   *
   * The shell's realtime handler drops an event whose scopes do not name the
   * ACTIVE tab, which is right for the shell's own loads and wrong for a
   * component-local fetch mounted somewhere else — #1207's maintenance-spend
   * report sits on the finance overview as well as on the Things screen, so an
   * inventory change reaching it depended on which tab happened to be open.
   * This fires before that filter, for exactly the same reason `bms` and
   * `floorPlan` exist: a screen that fetches for itself has no other way to
   * hear about a change somebody else made.
   */
  inventory: "household:inventory-refresh",
  projects: "household:projects-refresh",
  floorPlan: "household:floor-plan-refresh",
  garden: "household:garden-refresh",
  bms: "household:bms-refresh",
  network: "household:network-refresh",
  feedback: "household:feedback-refresh",
  /**
   * The Recipes home fetches its own card-sized pages (#1677) rather than
   * reading a shell-held catalog, so a saved recipe or a stock change reaches
   * it the same way the six self-fetching tabs above are reached.
   */
  recipes: "household:recipes-refresh"
} as const;

export type FeatureRefreshTarget = keyof typeof featureRefreshEvents;

export function dispatchFeatureRefresh(target: FeatureRefreshTarget): void {
  window.dispatchEvent(new Event(featureRefreshEvents[target]));
}

export function addFeatureRefreshListener(target: FeatureRefreshTarget, listener: () => void): () => void {
  const eventName = featureRefreshEvents[target];
  const handler = () => listener();
  window.addEventListener(eventName, handler);
  return () => window.removeEventListener(eventName, handler);
}
